/**************************
* Entry point for main.js *
**************************/

// load modules
import Navigation from './navigation';
import ImgToBackground from './ImgToBackground';
import BackgroundVideo from './BackgroundVideo';
import VideoComponent from './VideoComponent';
import './responsive-videos';
import './cookie-popup';

// init modules
const imgToBgd = ImgToBackground(jQuery);

/*#####################
### DOM ready calls ###
#####################*/
jQuery(function ($) {

    // init navigation module
    const navigation = new Navigation($);
    navigation.init();
    const bgVideo = new BackgroundVideo();

    // load images in DOM
    imgToBgd.lazyLoadImages('.js-img-template');

    const videoComponent = new VideoComponent();

});

/*#######################
### Window load event ###
#######################*/
jQuery(window).load(function () {
    imgToBgd.makeImgBackground('.js-image-imgtobg', '.js-background-imgtobg');
});
